import { useState, useEffect } from 'react';

const useIsSuperAdmin = () => {
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);

    useEffect(() => {
        const role = localStorage.getItem('role');
        setIsSuperAdmin(role === 'nkenne');
    }, []);

    return isSuperAdmin;
};

export default useIsSuperAdmin;
